import { render } from "./companyreport.vue?vue&type=template&id=48d8c67e"
import script from "./companyreport.vue?vue&type=script&lang=js"
export * from "./companyreport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__